<template>
  <div>
    <v-list shaped>
      <v-list-item @click="openDialog()">
        <v-list-item-icon>
          <v-icon>mdi-account</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title >{{membre.nom}} <v-chip :class="'ma-2 '+getColor(membre.sexe) " text-color="white">{{getSexe(membre.sexe)}}</v-chip> </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-dialog v-model="dialog" fullscreen transition="dialog-transition">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="annuler">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title> {{ membre.nom }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn rounded color="success" @click="sauvegarder"
              ><v-icon left dark> mdi-content-save </v-icon>Sauvegarder</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <td v-for="(detailEtape, index) in detailEtapes"
            :key="index"> {{ detailEtape.ll_details_etapes }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td  v-for="(detailEtape, index) in detailEtapes"
            :key="index">
            <fiche
                :key="Date.now()"
                @initCompute="remoteInitCompute"
                :membre="membre"
                :detailEtape="detailEtape"
                :etapeEffective="etapeEffective"
              />
          </td>
              </tr>
            </tbody>
          </v-simple-table>
        <!--   <v-card
            class="elevation-1 pa-2 ma-2 rounded blue-grey lighten-5"
            v-for="(detailEtape, index) in detailEtapes"
            :key="index"
          >
            <v-card-text>
              {{ detailEtape.ll_details_etapes }}
              <fiche
                :key="Date.now()"
                @initCompute="remoteInitCompute"
                :membre="membre"
                :detailEtape="detailEtape"
                :etapeEffective="etapeEffective"
              />
            </v-card-text>
          </v-card> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {
    fiche: require("@/components/fiche.vue").default,
  },
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    detailEtapes: { type: Array, required: true },
    membre: { type: Object, required: true },
    etapeEffective: { type: Object, required: true },
  },
  methods: {
    getSexe(sexe) {
      if (sexe == "1" || sexe == 1) {
        return "Masculin";
      } else  if(sexe == "0" || sexe == 2) {
        return "Féminin";
      } else { return "Nan"}
    },

    getColor(sexe) {
      if (sexe == "1" || sexe == 1) {
        return "blue";
      } else  if(sexe == "0" || sexe == 2) {
        return "green";
      } else { return "red"}
    },
    remoteInitCompute(payload) {
      payload.typeChamp = this.detailEtapes[0].typeChamp;
      this.$emit("initCompute", payload);
    },
    openDialog() {
      this.dialog = true;
    },
    sauvegarder() {
      this.dialog = false;
    },
    annuler() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="css" scoped>
.red { background-color: red;}
.blue { background-color: blue;}
.green { background-color: green;}
</style>
